export default __webpack_public_path__ + "static/media/sharepoint.4205be55.png";